import {Yii} from "libraries/interfaces/Yii";

export const WORDING : {[key:string]:string}={
    travellers: Yii.t('wui-iqba-js', 'Voyageurs'),
    includedServices: Yii.t('wui-iqba-js', 'Services inclus'),
    beginFlexibility: Yii.t('wui-iqba-js', 'Flexibilité des départs'),
    oneWay: Yii.t('wui-iqba-js', 'Aller Simple'),
    'return': Yii.t('wui-iqba-js', 'Aller-Retour'),
    multiple: Yii.t('wui-iqba-js', 'Multi-destinations'),
    close: Yii.t('wui-iqba-js', 'Fermer'),
    journeySearch: Yii.t('wui-iqba-js', "Recherche d'itinéraire"),
    newSearch: Yii.t('wui-iqba-js', 'Nouvelle Recherche'),
    hosts: Yii.t('wui-iqba-js', 'Sources'),
    locator: Yii.t('wui-iqba-js', 'Agence'),
    maxVias: Yii.t('wui-iqba-js', 'Etapes'),
    cabin: Yii.t('wui-iqba-js', 'Classe cabine'),
    fullServiceCarriersOnly: Yii.t('wui-iqba-js', 'Restrictions'),
    backToWTB: Yii.t('wui-iqba-js', "Retour à Watabi"),
    incorrectHost: Yii.t('wui-shared-js', 'Les sources fournies pour la recherche ne sont pas disponibles pour ces critères, veuillez modifier vos critères.')
};
